import { createAction, props } from '@ngrx/store';
import { LiveClassDTO, LiveClassResponse } from './models/live-class.dto';
import { LiveClass, LiveClassResponseDTO } from './models/live-class';
import { Invoice } from '../../../models/invoice.model';
import { Payment } from '../order/order.model';
import { HttpErrorResponse } from '@angular/common/http';
import { Subscription } from '../subscription/subscription.model';

export const initiateLiveClassCreation = createAction(
  '[Live Class API] Initiate Live Class Creation'
);

export const createLiveClass = createAction(
  '[Live Class API] Create Live Class',
  props<{ liveClassDTO: LiveClassDTO }>()
);

export const createLiveClassSuccess = createAction(
  '[Live Class API] Create Live Class Success',
  props<{ liveClass: LiveClass }>()
);

export const createLiveClassFailed = createAction(
  '[Live Class API] Create Live Class Failed',
  props<{ error: any }>()
);

export const fetchAllLiveClasses = createAction(
  '[Live Class API] Fetch All Live Classes',
  props<{ page: number }>()
);

export const fetchAllLiveClassesSuccess = createAction(
  '[Live Class API] Fetch All Live Classes Success',
  props<{ response: LiveClassResponse; forInstructor?: boolean }>()
);

export const fetchAllLiveClassesFailed = createAction(
  '[Live Class API] Fetch All Live Classes Failed',
  props<{ error: any }>()
);

export const fetchAllForInstructor = createAction(
  '[Live Class API] Fetch All Live Classes for Instructor'
);

export const restoreLiveClassItem = createAction(
  '[Live Class API] Restore Created Live Class',
  props<{ id: string }>()
);

export const restoreLiveClassItemSuccess = createAction(
  '[Live Class API] Restore Created Live Class Success',
  props<{ item: LiveClass }>()
);

export const updateLiveClass = createAction(
  '[Live Class API] Update Live Class',
  props<{ liveClassId: string; liveClass: LiveClassDTO; redirectTo?: string }>()
);

export const updateLiveClassSuccess = createAction(
  '[Live Class API] Update Live Class Success',
  props<{ liveClass: LiveClass }>()
);

export const updateLiveClassFailed = createAction(
  '[Live Class API] Update Live Class Failed',
  props<{ error: any }>()
);

export const selectLiveClass = createAction(
  '[Live Class API] Select Live Class Item',
  props<{ id: string }>()
);

export const selectLiveClassSuccess = createAction(
  '[Live Class API] Select Live Class Item Success',
  props<{ liveClass: LiveClassResponseDTO }>()
);

// Sent for review
export const requestForReview = createAction(
  '[Live Class API] Send review request',
  props<{ liveClassId: string }>()
);

export const requestForReviewSuccess = createAction(
  '[Live Class API] Request For review success',
  props<{ liveClass: LiveClass }>()
);

export const requestForReviewFailed = createAction(
  '[Live Class API] Request For review failed',
  props<{ error: any }>()
);

// Publish Live Class directly
export const publishLiveClass = createAction(
  '[Live Class API] Publish Live Class',
  props<{ liveClassId: string }>()
);

export const publishLiveClassSuccess = createAction(
  '[Live Class API] Publish Live Class success',
  props<{ liveClass: LiveClass }>()
);

export const publishLiveClassFailed = createAction(
  '[Live Class API] Publish Live Class failed',
  props<{ error: any }>()
);

export const subscribeToLiveClass = createAction(
  '[Subscription API] Subscribe to Live Class',
  props<{
    id: string;
    paymentType: string;
    targetEvent?: { meetingId: string; eventDate: Date };
  }>()
);

export const subscribeToLiveClassSuccess = createAction(
  '[Subscription API] Subscribe to Live Class Success',
  props<{ invoice: Invoice | null, subscription: Subscription }>()
);

export const subscribeToLiveClassFailed = createAction(
  '[Subscription API] Subscribe to Live Class Failed',
  props<{ error: any }>()
);

export const processPayment = createAction(
  '[Subscription API] Process Payment',
  props<{ invoiceId: string; payment: Payment }>()
);

export const processSuccess = createAction(
  '[Subscription API] Process Payment Success',
  props<{ invoice: Invoice }>()
);

export const processPaymentFailed = createAction(
  '[Subscription API] Process Payment Failed',
  props<{ err: HttpErrorResponse }>()
);

export const fetchInvoice = createAction(
  '[Invoice API] Fetch Invoice',
  props<{ invoiceId: string }>()
);

export const fetchInvoiceFailed = createAction(
  '[Invoice API] Fetch Invoice Failed',
  props<{ err: HttpErrorResponse }>()
);

export const fetchInvoiceSuccess = createAction(
  '[Invoice API] Fetch Invoice Success',
  props<{ invoice: Invoice }>()
);

// fetch subscriptions for current user
export const fetchSubscribedLiveClasses = createAction(
  '[Subscription API] Fetch All User Subscriptions'
);

export const fetchSubscribedLiveClassesSuccess = createAction(
  '[Subscription API] Fetch All User Subscriptions Success',
  props<{ subscribedLiveClasses: LiveClass[] }>()
);
